import { Box, Container, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PageNavigationCard from '../common/PageNavigationCard';
import PageHeader from '../common/PageHeader';
import { PageDetails } from './config';

export default function ATS() {
  const id = 'ats';
  const [pageDetails, setPageDetails] = useState({});
  const [atsPages, setAtsPages] = useState([]);

  useEffect(() => {
    loadCurrentPageDetails();
    loadSubPages();
  }, []);

  //θ(N) where N is the number of pages
  //Search for current page details and set in state
  const loadCurrentPageDetails = () => {
    const pageDetails = PageDetails[id];
    setPageDetails(pageDetails);
  };

  //θ(N) where N is the number of pages
  //Get all subpages and set in state
  const loadSubPages = () => {
    const pages = { ...PageDetails };
    delete pages[id]; // Remove the index page's path from sub pages list
    setAtsPages(Object.values(pages));
  };

  return (
    <React.Fragment>
      <div id={`${id}__div_pageWrapper`} className={`myOdu__${id}`}>
        {Object.values(pageDetails).length && (
          <Container id={`${id}__container_pageWrapper`} className="myOdu__container secondaryPage">
            <PageHeader id={id} title={pageDetails?.title} pageConfig={PageDetails} />

            <Box id={`${id}__box_wrapper`} className={'wrapper'}>
              <Stack
                id={`${id}__row_atsOptions`}
                direction={{ xs: 'column', lg: 'row' }}
                spacing={2}
              >
                {atsPages.map((item) => {
                  if (!item.isHide) {
                    return (
                      <PageNavigationCard
                        url={pageDetails.url}
                        id={id}
                        subPage={item}
                        header={'h4'}
                      />
                    );
                  }
                })}
              </Stack>
            </Box>
          </Container>
        )}
      </div>
    </React.Fragment>
  );
}
